export const getStyle = () => ({
  preexecuteContainer: {
    display: 'flex',
    flex: '1 0 auto',
    flexDirection: 'column',
    position: 'absolute',
    top: -9999,
    left: -9999,
    height: '100%',
    width: '100%',
    visibility: 'hidden',
  },
});
